import React from 'react';
import {Button, makeStyles, Modal} from '@material-ui/core';
import {TutorialPhase} from "./gamestuff/tutorial/TutorialWorldScene";
import {CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, DotGroup} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import './Tutorial.css'

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

function phaseMovingAround(props: any) {
    return <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={130}
        totalSlides={2}
    >
        <Slider>
            <Slide index={0}>
                <h2>Welcome to EventBit!</h2>
                <h4>
                    This is the lobby. Here we'll walk through how to interact
                    in the event space. After you get the basics, we'll open
                    the gate to the main space!
                </h4>
            </Slide>
            <Slide index={1}>
                <div className={"tut-panel"}>
                    <div className={"tut-content"}>
                        <h2>Moving Around</h2>
                        <h4>You can navigate around the event space using arrow keys.</h4>

                        <img src={"/assets/maps/tutorial/cursors.png"}/>
                        <h4>Try it out! Walk over to the sign and touch it.</h4>
                        <img src={"/assets/maps/tutorial/walkdog.gif"}/>

                    </div>
                    <Button
                        variant="outlined"
                        onClick={() => props.stopShowingGameOverlay()}
                    >
                        Let's Go!
                    </Button>
                </div>
            </Slide>
        </Slider>
        <DotGroup/>
        <ButtonBack>Back</ButtonBack>
        <ButtonNext>Next</ButtonNext>
    </CarouselProvider>
}

function phaseChatting(props: any) {
    return <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={130}
        totalSlides={2}
    >
        <Slider>
            <Slide index={0}>
                <h2>Communicating</h2>
                <h4>
                    <p>At it's core, EventBit is a virtual event space where you can interact with other
                        people, much like a real event! Of course that means communicating.</p>
                    <p>
                        There are two basic ways you can communicate: text and video. Text chat happens
                        when you are close to other people. If you are close enough, you can type a message,
                        and anybody in range will see it. Video chat happens at video chat nodes.
                    </p>
                </h4>
            </Slide>
            <Slide index={1}>
                <div className={"tut-panel"}>
                    <div className={"tut-content"}>
                        <h2>Text Chatting</h2>
                        <h4>
                            Text messages are like speaking in the real world. From far away, you can see if somebody's
                            talking, but you need to be close to hear.
                        </h4>


                    </div>
                    <Button
                        variant="outlined"
                        onClick={() => props.stopShowingGameOverlay()}
                    >
                        Let's Go!
                    </Button>
                </div>
            </Slide>
        </Slider>
        <DotGroup/>
        <ButtonBack>Back</ButtonBack>
        <ButtonNext>Next</ButtonNext>
    </CarouselProvider>
}

function phaseCondition(props: any, phase: TutorialPhase) {
    if (phase === TutorialPhase.MovingAround) {
        return phaseMovingAround(props)
    } else if (phase === TutorialPhase.Chatting) {
        return phaseChatting(props)
    } else {
        return <div>{phase}</div>
    }
}

export default function GameOverlayModalBox(props: any) {

    const useStyles = makeStyles((theme) => ({
        paper: {
            position: 'absolute',
            width: 500,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        },
    }));
    const classes = useStyles();

    return (

        <Modal
            open={props.gameOverlayMessage !== null}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            {props.gameOverlayMessage &&
            <div style={getModalStyle()} className={classes.paper}>
                {props.gameOverlayMessage.phase ?
                    phaseCondition(props, props.gameOverlayMessage.phase)
                    :
                    <>
                        <h2>{props.gameOverlayMessage.title}</h2>
                        <h4>{props.gameOverlayMessage.body}</h4>
                        <Button
                            variant="outlined"
                            onClick={() => props.stopShowingGameOverlay()}
                        >
                            Close
                        </Button>
                    </>
                }

            </div>
            }
        </Modal>
    );
}

